import { gql } from "@apollo/client";
import { post, fetchLang } from '@util/http';
import { getSsOUrl } from '@util/utils';

export const INDEX_DATA = gql`
  query _INDEX_DATA($option: Object) {
    indexPage(option: $option) {
      result
      success
      info
    }
  }
`;
const headers = {
	"content-type": "application/json"
}

// Web端严选资材首页-产品列表
export function indexPage(params) {
	return fetchLang('/api/product/indexPage', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

/**
*  获取盘八斗token
*/
export const queryPZToken = () => post(getSsOUrl()+'/auth/doRelativeLogin', { platform:'MATERIAL' });